import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import authService from '../../services/authService';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }
    try {
      setLoading(true);
      await authService.forgotPassword(email);
      navigate('/auth/email-sent', { state: { email } });
    } catch (error) {
      const errorMessage = error.message || 'Failed to send reset link. Please try again.';
      
      // Show longer toast for rate limit messages
      if (errorMessage.includes('Too many')) {
        toast.error(errorMessage, { duration: 6000 });
      } else {
        toast.error(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-16 bg-white p-8 rounded-xl shadow-lg">
      <h1 className="text-2xl font-bold text-gray-800 mb-2 text-center">Forgot Password?</h1>
      <p className="text-gray-600 mb-6 text-center">
        Enter your email address and we'll send you a link to reset your password.
      </p>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="email" className="form-label">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            className="form-input"
            placeholder="you@example.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="btn-primary w-full flex justify-center"
        >
          {loading ? (
            <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white"></div>
          ) : (
            'Send Reset Link'
          )}
        </button>
      </form>
      <div className="mt-6 text-center">
        <Link to="/auth/login" className="text-primary-600 hover:underline text-sm">Back to Login</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
